export const selectOmStatistikkenValgt = (state) => {
    let kodeverk = null
    if (state.omStatistikkenKodeverk && state.omStatistikkenKodeverk.omStatistikkenValgt) {
        kodeverk = state.omStatistikkenKodeverk.omStatistikkenValgt
    }
    return kodeverk
}
